module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2 mt-50"
  }, [_c('user-id-textarea', {
    staticClass: "form-control",
    attrs: {
      "placeholder": '批量输入用户ID请用英文逗号隔开，最多 ' + _vm.max + ' 个用户',
      "rows": "18",
      "separator": _vm.setting.separator,
      "userId": _vm.setting.userId
    },
    on: {
      "change": _vm.updateUserId
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.setting.userId))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-06977cf2"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/js/app/demo/component/App.vue
// module id = 47
// module chunks = 0